import { render, staticRenderFns } from "./AssessmentSection2.vue?vue&type=template&id=01b03677&scoped=true&"
import script from "./AssessmentSection2.vue?vue&type=script&lang=ts&"
export * from "./AssessmentSection2.vue?vue&type=script&lang=ts&"
import style0 from "./AssessmentSection2.vue?vue&type=style&index=0&id=01b03677&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b03677",
  null
  
)

export default component.exports